import { AxiosResponse } from 'axios';
import { keyBy } from 'lodash';
import { useQuery } from 'react-query';

// configs
import { API } from 'configs/api';
// utils
import { getShortUrlFromUrl } from 'utils/url';
// keys
import { reactionsQueryKeys } from './reactionsQueryKeys';

const getReactionCommentsQuery = async (visitorCode: string | null) => {
  const shortUrl = getShortUrlFromUrl();
  if (!shortUrl) {
    return {};
  }

  const response: AxiosResponse = await API.get(
    `/playback/${shortUrl}/reactions?visitorCode=${visitorCode}`
  );

  return keyBy(response.data, 'reactionId');
};

export const useGetReactionCommentsQuery = (visitorCode: string | null) => {
  return useQuery(
    [...reactionsQueryKeys.all()],
    () => getReactionCommentsQuery(visitorCode),
    { enabled: visitorCode != null }
  );
};
